import { SourceContent, SourcePage } from '@root/store/actions/videoAnalytics';
import useIFrameInteractionTracking from '@components/shared/useIFrameInteractionTracking';
import s from './ThreeDTour.module.less';

export type Props = {
  tourEmbedUrl: string;
  sourceContent: SourceContent;
  sourcePage: SourcePage;
};

const ThreeDTour = ({ tourEmbedUrl, sourceContent, sourcePage }: Props) => {
  useIFrameInteractionTracking({
    shouldTrack: tourEmbedUrl,
    sourceContent,
    sourcePage,
    iFrameId: 'ThreeDTour',
  });

  return (
    <iframe
      src={tourEmbedUrl}
      title="3D Tour"
      id="ThreeDTour"
      data-testid="ThreeDTour"
      className={s.container}
    ></iframe>
  );
};

export default ThreeDTour;
